import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "@/App.css";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import AuthorLayout from "@/components/AuthorLayout";
import AdminLayout from "@/components/AdminLayout";
import Login from "@/pages/Login";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Account from "@/pages/Account";
import AuthorDashboard from "@/pages/AuthorDashboard";
import Statements from "@/pages/Statements";
import Resources from "@/pages/Resources";
import Contact from "@/pages/Contact";
import AdminOverview from "@/pages/admin/AdminOverview";
import AdminAuthors from "@/pages/admin/AdminAuthors";
import AdminTitles from "@/pages/admin/AdminTitles";
import AdminUpload from "@/pages/admin/AdminUpload";
import AdminRoyalty from "@/pages/admin/AdminRoyalty";
import AdminPayments from "@/pages/admin/AdminPayments";
import AdminDirectSales from "@/pages/admin/AdminDirectSales";
import AdminReconciliation from "@/pages/admin/AdminReconciliation";
import AdminLogins from "@/pages/admin/AdminLogins";

function RoleHome() {
  const { user, bootstrapped } = useAuth();
  if (!bootstrapped) return null;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role === "admin") return <Navigate to="/admin" replace />;
  return <AuthorDashboard />;
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Toaster
          position="bottom-right"
          toastOptions={{
            style: { fontFamily: "'Josefin Sans', sans-serif", borderRadius: 12, border: "1px solid #E5E2D8" },
          }}
        />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/forgot" element={<ForgotPassword />} />
          <Route path="/reset" element={<ResetPassword />} />

          {/* Author area */}
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <AuthorLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<RoleHome />} />
            <Route path="statements" element={<ProtectedRoute role="author"><Statements /></ProtectedRoute>} />
            <Route path="resources" element={<ProtectedRoute role="author"><Resources /></ProtectedRoute>} />
            <Route path="contact" element={<ProtectedRoute role="author"><Contact /></ProtectedRoute>} />
            <Route path="account" element={<Account />} />
          </Route>

          {/* Admin area */}
          <Route
            path="/admin"
            element={
              <ProtectedRoute role="admin">
                <AdminLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<AdminOverview />} />
            <Route path="authors" element={<AdminAuthors />} />
            <Route path="titles" element={<AdminTitles />} />
            <Route path="upload" element={<AdminUpload />} />
            <Route path="royalty" element={<AdminRoyalty />} />
            <Route path="payments" element={<AdminPayments />} />
            <Route path="direct-sales" element={<AdminDirectSales />} />
            <Route path="reconciliation" element={<AdminReconciliation />} />
            <Route path="logins" element={<AdminLogins />} />
            <Route path="account" element={<Account />} />
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
